import CenteredSpinner from "@/components/CenteredSpinner";
import { Card, CardHeader, CardTitle } from "@/components/ui/card";
import SmartLabel from "@/domain/enums/SmartLabel";
import useGetDashboardRepartition from "@/hooks/dashboard/useGetDashboardRepartition";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import BubbleChart from "./BubbleChart";

const Repartition = () => {
    const { t } = useTranslation();

    const { data: repartitionData, isLoading } = useGetDashboardRepartition();

    const repartitionDataWithoutTraites = useMemo(
        () => repartitionData?.filter((d) => d.id !== SmartLabel.Traites) || [],
        [repartitionData],
    );

    return (
        <Card
            className="h-auto min-w-[140px] px-0"
            size="sm"
            variant="dashboard"
        >
            <CardHeader className="px-4">
                <CardTitle>
                    {t("dashboard.widgets.repartition.title")}
                </CardTitle>
            </CardHeader>
            {isLoading || !repartitionData ? (
                <CenteredSpinner />
            ) : (
                <BubbleChart data={repartitionDataWithoutTraites} />
            )}
        </Card>
    );
};

export default Repartition;
